import { createSlice } from '@reduxjs/toolkit';
import { AppDomain } from '@ibk/shared-types';
const initialState = {
    appDomain: AppDomain.ESCRITORIO,
};
const applicationSlice = createSlice({
    name: 'application',
    initialState,
    reducers: {
        setAppDomain: (state, action) => {
            state.appDomain = action.payload.appDomain;
        },
    },
});
export const { setAppDomain } = applicationSlice.actions;
export default applicationSlice.reducer;
